// extracted by mini-css-extract-plugin
module.exports = {"container":"TagsList_container__2a4Wz","tags":"TagsList_tags__1PnQl","tag":"TagsList_tag__16I_g"};